import { FunctionComponent } from 'react';

import { BaseSelect } from '../Common/Select/BaseSelect';
import { CreatableOption } from '../Common/Select/components/CreatableOption/CreatableOption';

import { CreatableSearchProps } from '../Common/Select/components/CreatableOption/CreatableOption';
import { SingleOnChangeArgs } from '../Common/Select/sharedTypes';
import { CommonSingleSelectProps } from '../Common/Select/BaseSelect';

type CreatableSearchSelectProps = CommonSingleSelectProps & CreatableSearchProps;

export const CreatableSearchSelect: FunctionComponent<CreatableSearchSelectProps> = props => {
    const { promptGenerator, createOptionHandler, onChange, name, ...commonProps } = props;

    function creatableOnChange(option: SingleOnChangeArgs): void {
        if (option && option.value === 'CREATABLE_OPTION_CREATED') {
            createOptionHandler({ inputValue: option.label, name });
        } else {
            onChange(option);
        }
    }

    return (
        <BaseSelect
            {...commonProps}
            onChange={creatableOnChange}
            name={name}
            searchable
            customDropdownOption={({
                getItemProps,
                closeMenu,
                filteredOptions,
                inputValue,
                isLoading,
            }) => {
                if (
                    !!inputValue &&
                    !isLoading &&
                    !filteredOptions.some(
                        option => option.label.toLowerCase() === inputValue.toLowerCase()
                    ) &&
                    inputValue.length > 2
                ) {
                    return (
                        <CreatableOption
                            borderTop={filteredOptions.length > 0}
                            closeMenu={closeMenu}
                            getItemProps={getItemProps}
                            inputValue={inputValue}
                            promptGenerator={promptGenerator}
                        />
                    );
                }
                return null;
            }}
        />
    );
};
